import styled from "styled-components"
import { mobile, mobilePortrait, tablet, medScreen } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
    
    ${mobile({ overflowY: "hidden" })}    
`

export const Wrapper = styled.div`
    margin-top: 100px;
    padding: 20px;
    min-height: 85vh;

    ${tablet({ marginTop: "80px"})}
    ${mobile({ marginTop: "60px", padding: "10px"})}
    ${mobilePortrait({ marginTop: "40px"})}
`

export const Title = styled.h1`
    font-weight: 300;
    text-align: center;
`

export const Top = styled.div`
    width: 30%;
    padding: 20px 0px;
    display: flex;
    justify-content: left;

    ${tablet({ width: "50%" })}
    ${mobile({ padding: "10px", width: "100%" })}
`

export const Bottom = styled.div`
    display: flex;
    justify-content: space-between;

    ${tablet({ flexDirection: "column" })}
    ${mobile({ flexDirection: "column" })}
`

export const Info = styled.div`
    flex: 3;
`

export const Product = styled.div`
    display: flex;
    justify-content: space-between;

    ${mobile({ flexDirection: "column" })}
`

export const ProductDetail = styled.div`
    flex: 3;
    display: flex;
`

export const Image = styled.img`
    width: 400px;

    ${tablet({ width: "300px", objectFit: "cover" })}
    ${mobile({ width: "200px", objectFit: "cover" })}
`

export const Details = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: var(--fontM);

    @media screen and (max-width: ${medScreen}) {
        font-size: var(--fontS);
    }
`

export const ProductName = styled.span``

export const ProductId = styled.span``

export const ProductDetailColor = styled.span``

export const ProductSize = styled.span``

export const PriceDetail = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

export const AmountContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
`

export const Amount = styled.div`
    font-weight: 700;
    width: 30px;
    height: 30px;
    border-radius: 10px;
    border: 1.5px solid var(--secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px 5px;
`

export const Price = styled.div`
    font-size: 30px;
    font-weight: 200;
    margin-top: 10px;
    margin-bottom: 20px;
`

export const Hr = styled.hr`
    background-color: var(--secondary);
    border: none;
    height: 1.5px;
    margin-bottom: 10px;
`

export const Summary = styled.div`
    flex: 1;
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    padding: 20px;
    max-height: 450px;
`

export const SummaryTitle = styled.h1`
    font-weight: 200;
`

export const SummaryItem = styled.div`
    margin: 30px 0px;
    display: flex;
    justify-content: space-between;
    font-weight: ${props => props.type === "total" && "500"};
    font-size: ${props => props.type === "total" && "24px"};
`

export const SummaryItemText = styled.span``

export const SummaryItemPrice = styled.span``
